var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { t } from "../I18N";
import LibraryFilters from "./components/LibraryFilters";
import { QuickLabelPanel } from "./components/QuickLabelPanel";
import ViewMetadataPanel from "./components/ViewMetadataPanel";
import SelectMultiplePanelContainer from "./containers/SelectMultiplePanelContainer";
import { FeatureToggleSemanticSearch } from "../SemanticSearch/components/FeatureToggleSemanticSearch";
import SemanticSearchPanel from "../SemanticSearch/components/SemanticSearchPanel";
import ImportPanel from "../Uploads/components/ImportPanel";
import { QuickLabelHeader } from "./components/QuickLabelHeader";
import { LibraryFooter } from "./components/LibraryFooter";

class LibraryLayoutBase extends Component {
  render() {
    const { className, children, quickLabelThesaurus, sidePanelMode, scrollCallback, scrollCount } =
    this.props;
    const contentDivClass = `${
    quickLabelThesaurus ? 'with-header ' : ''
    } content-holder library-viewer document-viewer with-footer with-panel ${sidePanelMode} ]`;

    return /*#__PURE__*/(
      _jsx("div", { className: "row panels-layout" }, void 0, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, t('System', 'Library', null, false))),

      quickLabelThesaurus && /*#__PURE__*/_jsx(QuickLabelHeader, {}), /*#__PURE__*/
      _jsx("div", { className: contentDivClass, onScroll: scrollCallback }, void 0, /*#__PURE__*/
      _jsx("main", { className: `${className}` }, void 0, children), /*#__PURE__*/
      _jsx(LibraryFooter, { storeKey: "library", scrollCount: scrollCount }), /*#__PURE__*/
      _jsx(LibraryFilters, { storeKey: "library", sidePanelMode: sidePanelMode }),
      !quickLabelThesaurus && /*#__PURE__*/_jsx(ViewMetadataPanel, { storeKey: "library" }),
      !quickLabelThesaurus && /*#__PURE__*/_jsx(SelectMultiplePanelContainer, { storeKey: "library" }),
      quickLabelThesaurus && /*#__PURE__*/_jsx(QuickLabelPanel, { storeKey: "library" }), /*#__PURE__*/
      _jsx(FeatureToggleSemanticSearch, {}, void 0, /*#__PURE__*/
      _jsx(SemanticSearchPanel, { storeKey: "library" })), /*#__PURE__*/

      _jsx(ImportPanel, {}))));



  }
}

LibraryLayoutBase.defaultProps = {
  className: '',
  quickLabelThesaurus: '',
  sidePanelMode: '',
  scrollCallback: () => {},
  scrollCount: 0
};










export { LibraryLayoutBase };

export default connect((state) => ({
  quickLabelThesaurus: state.library.sidepanel.quickLabelState.get('thesaurus')
}))(LibraryLayoutBase);